import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Login from './Login';

import { login } from '../../actions/auth-actions';
import { selectFirstAllowedPage } from '../../reducers/user-reducer';

const mapStateToProps = ({ auth, user, errorMessage }) => ({
  contactEmail: 'insights-support@whipmedia.com',
  errorMessage,
  firstAllowedPage: selectFirstAllowedPage({ user }),
  loggedIn: auth.loggedIn
});

const mapDispatchToProps = dispatch => bindActionCreators({ login }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
